var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tooltip',{attrs:{"color":"primary","text":"Preview","position":"top"}},[_c('vs-button',{attrs:{"type":"border","icon-pack":"feather","icon":"icon-eye"},on:{"click":function($event){$event.stopPropagation();return _vm.params.colDef.CellRendererParams.openGradebookSidebar(_vm.params.data)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }